import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const ImageContainer = styled(Box)`
  width: 230px;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
`
